export default __webpack_public_path__ + "static/media/iphone.96a6f631.svg";